import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import withStoreProvider from "./components/providers/StoreProvider";

import { inIframe } from "./helpers/windowHelper";

import DonateWizard from "./pages/donate";
import ThankyouPage from "./pages/donate/thankyouPage";
import { RootState } from "./redux/store";

const App = () => {
  const defaultPath = "/:primaryPath/:secondaryPath";
  const pageReducer = useSelector((state: RootState) => state.page);
  const [title, setTitle] = useState("");
  const [favIcon, setFavIcon] = useState("./favicon.ico");
  const [description, setDescription] = useState("");

  if (inIframe()) {
    document.getElementsByTagName("body")[0].classList.add("in-iframe");
  }

  useEffect(() => {
    const campaign = pageReducer.campaign;
    const organization = pageReducer.organization;

    // org data
    if (organization) {
      setDescription(organization.template?.value?.missionStatement);
    }

    // campaign data
    if (campaign) {
      setTitle(campaign.name);
      let favIconTemp = campaign.mainImageUrl;
      if (campaign.template?.value?.customSetup?.favicon) {
        favIconTemp = campaign.template.value.customSetup.favicon;
      }
      setFavIcon(favIconTemp);
    }
  }, [pageReducer]);

  return (
    <>
      <Helmet
        link={[{ rel: "icon", type: "image/png", href: favIcon }]}
        title={title}
        meta={[
          {
            name: "description",
            content: description,
          },
        ]}
      />
      <Router>
        <Switch>
          <Route exact path={defaultPath} component={DonateWizard} />
          <Route exact path={`${defaultPath}/thankyou`} component={ThankyouPage} />
          <Route component={() => <Redirect to="/" />} />
        </Switch>
      </Router>
    </>
  );
};

export default withStoreProvider(App);
